import { asAddPage } from './svg/addPage';
import { asAddProject } from './svg/addProject';
import { asAdmin } from './svg/admin';
import { asAlert } from './svg/alert';
import { asAlerts } from './svg/alerts';
import { asAngleLeft } from './svg/angle-left';
import { asAngleDown } from './svg/angleDown';
import { asAngleUp } from './svg/angleUp';
import { asAppLogo } from './svg/appLogo';
import { asArchitecture } from './svg/architecture';
import { asArrow } from './svg/arrow';
import { asAtomsVector } from './svg/atomsVector';
import { asBell } from './svg/bell';
import { asBulkAction } from './svg/bulkAction';
import { asChatbot } from './svg/chatbot';
import { asChatBubble } from './svg/chatBubble';
import { asChecker } from './svg/checker';
import { asCircleCheck } from './svg/circleCheck';
import { asClipBoard } from './svg/clipboard';
import { asClose } from './svg/close';
import { asCollapse } from './svg/collapse';
import { asContact } from './svg/contact';
import { asCritial } from './svg/critical';
import { asDecision } from './svg/decisionIcon';
import { asDone } from './svg/done';
import { asDot3Hoz } from './svg/dot3Hoz';
import { asDownload } from './svg/download';
import { asDownloadCircle } from './svg/download-circle';
import { asDownloadFile } from './svg/downloadFile';
import { asEdit } from './svg/edit';
import { asExclamationMark } from './svg/exclamationMark';
import { asExpand } from './svg/expand';
import { asEye } from './svg/eye';
import { asField } from './svg/field';
import { asFile } from './svg/file';
import { asFileAction } from './svg/fileAction';
import { asFileVideo } from './svg/fileVideo';
import { asFlash } from './svg/flash';
import { asGraduate } from './svg/graduate';
import { asHelpCenter } from './svg/help-center';
import { asHelper } from './svg/helper';
import { asHierarchy } from './svg/hierarchy';
import { asHome } from './svg/home';
import { asHourGlass } from './svg/hourGlass';
import { asIOneSheet } from './svg/ionesheet';
import { asLight } from './svg/light';
import { asLink } from './svg/link';
import { asList } from './svg/listAlt';
import { asLiveSupport } from './svg/liveSupport';
import { asLL } from './svg/LL';
import { asLogoHall } from './svg/logoHall';
import { asMailbox } from './svg/mailbox';
import { asManageInfo } from './svg/manageInfo';
import { asMention } from './svg/mention';
import { asMentionVideo } from './svg/mentionVideo';
import { asMenuCollapse } from './svg/menuCollapse';
import { asMessage } from './svg/message';
import { asMsTeam } from './svg/msTeam';
import { noData } from './svg/noData';
import { asNoFilterData } from './svg/noFilterData';
import { asNominate } from './svg/nominate';
import { asNonSupport } from './svg/nonSupport';
import { asNotificationOff } from './svg/notificationOff';
import { asNotificationOn } from './svg/notificationOn';
import { asOffice } from './svg/office';
import { asOpenPreview } from './svg/openPreview';
import { asOperator } from './svg/operator';
import { asPDF } from './svg/pdf';
import { asPhone } from './svg/phone';
import { asPowerBI } from './svg/powerBI';
import { asProject } from './svg/project';
import { asProtocol } from './svg/protocol';
import { asPublic } from './svg/public';
import { asReadEnvelope } from './svg/readEnvelope';
import { asRedo } from './svg/redo';
import { asRegion } from './svg/region';
import { asRemovePage } from './svg/removePage';
import { asReset } from './svg/reset';
import { asRestore } from './svg/restore';
import { asRig } from './svg/rig';
import { asRightArrow } from './svg/rightArrow';
import { asRigSidebar } from './svg/rigSidebar';
import { asRigSite } from './svg/rigSite';
import { asRouting } from './svg/routing';
import { asSentSupport } from './svg/sentSupport';
import { asSeprerate } from './svg/seprerate';
import { asSetting } from './svg/setting';
import { asSignOut } from './svg/signOut';
import { asSingleUser } from './svg/singleUser';
import { asStar } from './svg/star';
import { asComplete } from './svg/status/complete';
import { asRequired } from './svg/status/required';
import { asStick } from './svg/stick';
import { asTime } from './svg/time';
import { asTimer } from './svg/timer';
import { asTrash } from './svg/trash';
import { asTranslation } from './svg/translation';
import { asUndo } from './svg/undo';
import { asUnReadEnvelope } from './svg/unReadEnvelope';
import { asUpLoad } from './svg/uploadFile';
import { asUser } from './svg/user';
import { asVideo } from './svg/video';
import { asWarning } from './svg/warning';
import { asWell } from './svg/well';

export const SvgIcons = [
  asChatBubble,
  asMenuCollapse,
  asLogoHall,
  asBell,
  asDot3Hoz,
  asHome,
  asSetting,
  asDone,
  asLight,
  asWarning,
  asCritial,
  asRigSite,
  asLink,
  asDecision,
  asTime,
  asRig,
  asMailbox,
  asHourGlass,
  asOperator,
  asPhone,
  asProject,
  asReadEnvelope,
  asUnReadEnvelope,
  asWell,
  asRegion,
  asRouting,
  asIOneSheet,
  asHierarchy,
  asClose,
  asEdit,
  asAddProject,
  asProtocol,
  asFile,
  asFileAction,
  asFileVideo,
  asUpLoad,
  asStar,
  asClipBoard,
  asContact,
  asStick,
  asAdmin,
  asUser,
  asReset,
  asHelper,
  asRigSidebar,
  asChecker,
  asPDF,
  asDownload,
  asAppLogo,
  asSignOut,
  asAlert,
  asLL,
  asAlerts,
  asNominate,
  noData,
  asPowerBI,
  asSingleUser,
  asField,
  asFlash,
  asOffice,
  asExclamationMark,
  asHelpCenter,
  asGraduate,
  asRightArrow,
  asArrow,
  asMention,
  asMentionVideo,
  asVideo,
  asAddPage,
  asRemovePage,
  asRestore,
  asUndo,
  asRedo,
  asSeprerate,
  asMsTeam,
  asLiveSupport,
  asNotificationOn,
  asNotificationOff,
  asSentSupport,
  asNonSupport,
  asMessage,
  asChatbot,
  asTranslation,
  asDownloadCircle,
  asPublic,
  asArchitecture,
  asEye,
  asAngleLeft,
  asTimer,
  asList,
  asBulkAction,
  asManageInfo,
  asCircleCheck,
  asAtomsVector,
  asAngleUp,
  asAngleDown,
  asNoFilterData,
  asRequired,
  asComplete,
  asDownloadFile,
  asOpenPreview,
  asTrash,
  asCollapse,
  asExpand,
];

export type IconSize =
  'xs' | 'xsm' | 'sm' | 'smd' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';

export const iconSizes: Record<IconSize, string> = {
  xs: '12px',
  xsm: '14px',
  sm: '16px',
  smd: '18px',
  md: '20px',
  lg: '24px',
  xl: '30px',
  xxl: '36px',
  xxxl: '40px',
};
